<template>
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.farmitteam.in" class="font-weight-bold ml-1" target="_blank"> Created with &hearts; by FarmIT</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <b-nav-item href="https://www.icpaunion.com"  target="_blank">
            ICPA
          </b-nav-item>
          <b-nav-item href="https://www.icpaunion.com" target="_blank">
           Constitution
          </b-nav-item>
          <b-nav-item href="https://www.icpaunion.com/news" target="_blank">
            News
          </b-nav-item>
          <b-nav-item href="https://www.icpaunion.com" target="_blank">
            Terms & Conditions
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
